import { Layout } from '@/components/Layout/Layout';
import ClientRecipesSlugPage from 'components/PageLevelComponents/ClientRecipesSlugPage';
import ClientRecipesSlugPagePrint from 'components/PageLevelComponents/ClientRecipesSlugPagePrint';
import { ANONYMOUS_TOKEN_NAME, LOCALE_DEFAULT } from 'config/config';
import { GetServerSideProps } from 'next';
import { RecipePageController } from 'server/controller/page/recipes/recipePageController';
import {
  IRecipePageErrorResource,
  IRecipePageResource,
} from 'server/resource/page/recipePageResource';
import { RecipeData, RecipeResult } from 'types/Recipes';
import RecipeNotFoundPage from '../404';

const RootPage = (props: IRecipePageResource | IRecipePageErrorResource) => {
  const {
    metaData,
    recipe,
    recipeCategorySlug,
    breadcrumbsCMSData,
    footerNavData,
    footerImage,
    locale,
    searchOverlayData,
    countrySelectorData,
    newsletterData,
    contactUsUrl,
    difficultyCopy,
    getHeaderNav,
    getMobileNavData,
    popularSearchData,
    cardCarouselCMSData,
    recallData,
    recipeData,
    relatedRecipes,
    nutritionDictionary,
    socialShareData,
    tipsAndTricksCardData,
    tipsAndTricksData,
    teasersLarge,
    teasersSmall,
    slug,
    pathTranslations,
    userToken,
    titleRecipe,
    descriptionRecipe,
  } = props as IRecipePageErrorResource;

  return (
    <Layout
      themeName={undefined}
      pathTranslations={pathTranslations}
      locale={locale}
      globalMetadata={metaData}
      getHeaderNav={getHeaderNav}
      getMobileNavData={getMobileNavData}
      popularSearchData={popularSearchData}
      footerNavData={footerNavData}
      footerImage={footerImage}
      searchOverlayData={searchOverlayData}
      countrySelectorData={countrySelectorData}
      newsletterData={newsletterData}
      contactUsUrl={contactUsUrl}
      difficultyCopy={difficultyCopy as Record<string, string>}
      cardCarouselCMSData={cardCarouselCMSData}
      recallData={recallData}
      userToken={userToken}
    >
      {'recipeNotFound' in props && props.recipeNotFound ? (
        <RecipeNotFoundPage
          slug={slug}
          popularSearchData={popularSearchData}
          searchOverlayData={searchOverlayData}
          locale={locale}
          metaData={metaData}
          titleRecipe={titleRecipe || ''}
          descriptionRecipe={descriptionRecipe || ''}
        />
      ) : (
        <>
          <ClientRecipesSlugPage
            recipe={recipe}
            recipeCategorySlug={recipeCategorySlug}
            recipeData={recipeData as unknown as RecipeData}
            relatedRecipes={relatedRecipes as RecipeResult[]}
            locale={locale}
            nutritionDictionary={nutritionDictionary}
            socialShareData={socialShareData}
            tipsAndTricksCardData={tipsAndTricksCardData}
            tipsAndTricksData={tipsAndTricksData}
            breadcrumbsCMSData={breadcrumbsCMSData}
            teasersLarge={teasersLarge}
            teasersSmall={teasersSmall}
            slug={slug}
            metaData={metaData}
          />
          <ClientRecipesSlugPagePrint
            logo={metaData?.logo?.url}
            recipe={recipe}
            recipeData={recipeData}
          />
        </>
      )}
    </Layout>
  );
};

export const getServerSideProps: GetServerSideProps = async ({
  locale,
  params,
  defaultLocale,
  resolvedUrl,
  req,
}) => {
  const anonymousToken = req.cookies[ANONYMOUS_TOKEN_NAME];

  return RecipePageController.getCachedRecipePageData({
    resolvedUrl,
    locale: locale || defaultLocale || LOCALE_DEFAULT,
    slug: Array.isArray(params?.slug) ? params?.slug.join('/') : (params?.slug ?? ''),
    userToken: anonymousToken ?? '',
  });
};

export default RootPage;
